import React from 'react';

import G_marketConfigStorage from 'components/globalMarketConfigStorage';
import { _I_ } from 'components/translate';
import { classMixer } from 'generics/utils';

export class ViewAppIdIcon extends React.Component  {
  render()  {
    const appDesc = G_marketConfigStorage.resolveAppId( this.props.appId );

    if ( this.props.mini )
      return (<div className="view-app-brief">
          <img className="view-app-icon" src={appDesc.icon} />
          {this.props.children}
        </div>);

    if ( this.props.compact )
      return (<div className="view-app-brief" title={appDesc.desc.join("\n")}>
          <img className="view-app-icon" src={appDesc.icon} />
          <div className="view-app-name">
            <b>{appDesc.briefName}</b>
          </div>
          {this.props.children}
        </div>);

    return (<div className="view-app-full">
        <img className="view-app-banner" src={appDesc.banner} />
        <div><b>{appDesc.name}</b></div>
        {appDesc.desc.map( (d, key) =>  (<div key={`d_${key}`}>{d}</div>) )}
      </div>);

  }
};

export class ViewItemProgress extends React.Component  {

  renderShortProgress( current, goal ) {
    let checkList = [];

    for (let i = 0; i < goal; i++) {
      let checkClass = i < current ? "fa-check-square" : "fa-square";
      checkList.push(<i
        key={`progress_${i}_${goal}`}
        className={classMixer("fa", checkClass)}
      ></i>);
    }

    return checkList;
  }

  render()  {
    const {  current, goal, timestamp, hidden } = this.props;
    const progress = (current / goal) * 100;
    const progressStyle = {"width":progress+'%'};

    if (hidden)
      return null;

    if ( current == goal )
    {
      const stamp = new Date(timestamp * 1000).toLocaleString();

      return (
        <div className="item-complete-date">
          <i className="fa fa-check-square"></i> {_I_("ViewItemDetailed.state.completed")} {stamp}
        </div>
      )
    }

    if ( goal <= 5 )
    {
      return (
        <div>
          {this.renderShortProgress(current, goal)} &nbsp; ({current} / {goal})
        </div>
      )
    }

    const currentView = current < 1000 ? current : (parseFloat((current / 1000).toFixed(2)) + "k");
    const goalView = goal < 1000 ? goal : (parseFloat((goal / 1000).toFixed(2)) + "k");

    return (
      <div>
        <div className="ViewItemProgress">
          <div className="progress-bar">
            <div className="progress-bar-state" style={progressStyle}></div>
          </div>
          &nbsp; ({currentView} / {goalView})
        </div>
      </div>
    );
  }
}